import type { Auth, GoogleAuthProvider } from 'firebase/auth';

// Public Firebase web config (not a secret).
const firebaseConfig = {
  projectId: 'goreal-app',
  appId: '1:652791859551:web:7b310ffb23988af12b0eea',
  storageBucket: 'goreal-app.firebasestorage.app',
  apiKey: 'AIzaSyDnJ9719mAYJZ47dct1_ngsKsMJhTxQg88',
  authDomain: 'goreal-app.firebaseapp.com',
  messagingSenderId: '652791859551',
};

let authPromise: Promise<Auth> | null = null;

/**
 * Lazily initialize Firebase Auth. The firebase SDK is only downloaded when
 * this is first called (sign-in click, or restoring a known session) so
 * anonymous visitors never pay for it.
 */
export function getFirebaseAuth(): Promise<Auth> {
  if (!authPromise) {
    authPromise = (async () => {
      const [{ initializeApp, getApps }, { getAuth }] = await Promise.all([
        import('firebase/app'),
        import('firebase/auth'),
      ]);
      const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
      return getAuth(app);
    })();
  }
  return authPromise;
}

export async function getGoogleProvider(): Promise<GoogleAuthProvider> {
  const { GoogleAuthProvider } = await import('firebase/auth');
  return new GoogleAuthProvider();
}
